<template>
  <section class="admin-section" aria-labelledby="admin-actions-heading">
    <PaymentsManagerSettingsList />
  </section>

  <section class="admin-section" aria-labelledby="admin-actions-heading">
    <div class="admin-header">
      <div class="admin-title-row">
        <h5 id="admin-actions-heading" class="admin-title">Administracja</h5>
        <span class="admin-badge">Sekcja tylko dla administratora</span>
      </div>
      <p class="admin-description">
        Narzędzia administracyjne związane z zarządzaniem płatnościami centralnymi.
      </p>
    </div>
    <div class="admin-actions">
      <button
          class="admin-action admin-action--primary"
          type="button"
          @click="bindDocumentsWithExtData"
      >
        <span class="admin-action__icon" aria-hidden="true">  <i class="fas fa-link align-middle font-size-16"/></span>
        <span class="admin-action__content">
              <span class="admin-action__title">Powiąż niepowiązane dokumenty z rekordami danych rozszerzających.</span>
              <span class="admin-action__subtitle">Uruchom procedurę</span>

            </span>
      </button>
      <!-- Przyszłe akcje administracyjne można dodawać jako kolejne przyciski w tej siatce -->
    </div>
  </section>



</template>

<script>
import PaymentsManagerSettingsList from "./PaymentsManagerSettingsList.vue";
import Swal from "sweetalert2";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PaymentsManagerSettingsStage",
  components: {
    PaymentsManagerSettingsList,
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
      underConstructionWarningDisplayed:true,
    };
  },
  methods: {
    bindDocumentsWithExtData(){
      // ask if user is sure to trigger this action, use Swal:
      Swal.fire({
        title: 'Czy na pewno chcesz powiązać niepowiązane dokumenty z rekordami danych rozszerzających?',
        text: "Ta operacja może potrwać kilka minut.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, powiąż dokumenty!',
        cancelButtonText: 'Anuluj'
      }).then((result) => {
        if (result.isConfirmed) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Powiązywanie danych dokumentów z rekordami danych rozszerzających...");
          this.paymentsModule.httpBindRawDocumentWithExtData();

        }
      });

    }

  },
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Ustawienia Centralnych Płatności`)
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>
.settings-stage {
  padding-left: 16px;
  padding-right: 16px;
}
</style>
